var React = require('react');

function OriginalsChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 14.6585L26.7344 16L14 2.67362L1.26562 16L-5.86394e-08 14.6585L14 -2.3943e-07L28 14.6585Z","fill":"currentColor"}));
}

OriginalsChevronUp.defaultProps = {"width":"28","height":"16","viewBox":"0 0 28 16","fill":"none"};

module.exports = OriginalsChevronUp;

OriginalsChevronUp.default = OriginalsChevronUp;
